<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.81145 16.71581">
		<path d="M12.81144 10.30908a.74758.74758 0 0 1-.21973.53028l-5.65675 5.65673a.74972.74972 0 0 1-1.06027.00027l-.00028-.00027-5.65672-5.65673a.74992.74992 0 0 1 1.06054-1.06054l5.12647 5.12645 5.12646-5.12645a.75.75 0 0 1 1.28028.53027Z"/>
		<path d="M7.1391.75v14.5a.75.75 0 1 1-1.5 0V.75a.75.75 0 0 1 .75-.75.75.75 0 0 1 .75.75Z"/>
	</svg>
</template>
